module.exports = __webpack_public_path__ + "img/195.931d0ded.jpg";